<template>
  <div class="flex items-center justify-center h-full bg-gray-50">
    <div class="text-center">
      <img src="/img/logo.png" alt="manufix logo" class="w-24 h-24 mx-auto mb-6 opacity-50" />
      <h2 class="text-3xl font-semibold text-gray-900 mb-4">Willkommen bei manufix</h2>
      <p class="text-lg text-gray-600 mb-8">Wählen Sie ein Projekt aus der Seitenleiste oder erstellen Sie ein neues Projekt.</p>
      <div class="flex justify-center gap-4">
        <UButton 
          label="Neues Projekt erstellen" 
          icon="i-lucide-plus"
          color="primary"
          size="lg"
        />
        <UButton 
          label="Dokumentation" 
          icon="i-lucide-book-open"
          color="gray"
          variant="outline"
          size="lg"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>